module.exports = __webpack_public_path__ + "991c767bd40667d710503f22c66b4f71.svg";